import { Component, h } from '@stencil/core';

@Component({
    tag: 'rentware-spinner-squares',
    styleUrl: 'style.sass',
    shadow: true,
})

export class RentwareSpinnerSquares {
    render() {
      return (
        <div class="loader-container">
          <div class="loader-square"></div>
          <div class="loader-square"></div>
          <div class="loader-square"></div>
        </div>
      )
    }
}
